import type * as CSS from 'csstype';
import styled from 'styled-components';

import style from '../../../style';
import type { Size as ThemeSize } from '../../../style/types/theme';
import { Size } from './types';

const getGapFromSize = (
  gap: CSS.Property.Gap,
  themeSize: ThemeSize,
): CSS.Property.Gap => {
  switch (gap) {
    case Size.DEFAULT:
      return themeSize.units(4);
    default:
      return gap;
  }
};

export const Underline = styled.div(({ theme: { color, size } }) => ({
  width: '100%',
  height: size.units(0.25),
  background: color.background.secondary.default(),
}));

interface WrapperProps {
  $gapBetweenItems: CSS.Property.Gap;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { size }, $gapBetweenItems }) => ({
    width: 'fit-content',
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'end',
    gap: getGapFromSize($gapBetweenItems, size),
    whiteSpace: 'nowrap',

    [Underline]: {
      position: 'absolute',
      left: 0,
      bottom: 0,
    },
  }),
);

interface ContainerProps {
  $hasOverflow: boolean;
}

export const Container = styled.div<ContainerProps>(({ $hasOverflow }) => ({
  width: 'fill-available',
  overflowX: 'auto',

  [Wrapper]: {
    margin: '0 auto',
    position: $hasOverflow ? 'relative' : undefined,
  },

  ...style.mixins.hideScrollbar(),
  ...style.mixins.devices.touchable({
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),

  ...style.mixins.responsive.sm.upward({
    position: 'relative',
  }),
}));
